import { HttpService } from "../services/http-service";

export class ServiceFactory {
  private services: Map<string, HttpService> = new Map();

  register(name: string, service: HttpService): void {
    this.services.set(name, service);
  }

  get(name: string): HttpService {
    const service = this.services.get(name);
    if (!service) {
      throw new Error(`Service '${name}' not found`);
    }
    return service;
  }

  has(name: string): boolean {
    return this.services.has(name);
  }

  getAll(): Map<string, HttpService> {
    return new Map(this.services);
  }
}
